import { Create } from 'react-admin'

import ApiCodeForm from './ApiCodeForm'

const ApiCodeCreate = props => (
  <Create redirect="list" {...props}>
    <ApiCodeForm />
  </Create>
)

export default ApiCodeCreate
